var _rect, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFerrariBannerDeep(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2259,
    height: 384,
    viewBox: "0 0 2259 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_1859)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2259,
    height: 384,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_31_1859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_31_1859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2400,
    height: 800
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2400 0H0V800H2400V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_31_1859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-23.5879 687.54L777.159 58.466H1268.83L300.33 819.329L-23.5879 818.53V687.54Z",
    fill: "url(#paint0_linear_31_1859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.44 -12.141L324.121 625.24H777.566L1589.9 -12.939L1135.44 -12.141Z",
    fill: "url(#paint1_linear_31_1859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.5874 513.738L368.856 205.431H748.286L-27.8574 815.176L-23.5874 513.738Z",
    fill: "url(#paint2_linear_31_1859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.018 -12.939L160.941 435.703H592.121L1165.49 -14.736L732.018 -12.939Z",
    fill: "url(#paint3_linear_31_1859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.143 -12.939L66.5928 228.674H637.67L952.26 -18.47L374.143 -12.939Z",
    fill: "url(#paint4_linear_31_1859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.799 -10.224L130.492 298.762H-178.938L219.529 -14.277L523.799 -10.224Z",
    fill: "url(#paint5_linear_31_1859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-178.938 449.84L194.608 156.38H622.622L-171.522 780.267L-178.938 449.84Z",
    fill: "url(#paint6_linear_31_1859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.674 -18.47L-78.8955 412.49H280.975L828.052 -17.297L469.674 -18.47Z",
    fill: "url(#paint7_linear_31_1859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1447.77 -14.736L1003.48 334.305H1574.65L2000.11 0.0600386L1447.77 -14.736Z",
    fill: "url(#paint8_linear_31_1859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2416.47 -12.141L1719.43 535.463H1268.83L1961.1 -8.38699L2416.47 -12.141Z",
    fill: "url(#paint9_linear_31_1859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.622 815.176L1425.37 184.527H1883.73L1078.93 816.784L622.622 815.176Z",
    fill: "url(#paint10_linear_31_1859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2416.47 105.102L2086.23 364.547H1649.48L2126.82 -10.455H2416.47V105.102Z",
    fill: "url(#paint11_linear_31_1859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1766.6 -10.455L1381.28 292.257H1903.25L2291.07 -12.418L1766.6 -10.455Z",
    fill: "url(#paint12_linear_31_1859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.63 480.511H888.183L1524.97 -19.756H2000.11L1317.63 480.511Z",
    fill: "url(#paint13_linear_31_1859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2368.49 -10.455L1771.8 458.305H2248.11L2411.21 330.171L2416.47 -10.455H2368.49Z",
    fill: "url(#paint14_linear_31_1859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2413.84 159.784L1773.5 662.843H2111.47L2409.3 428.866L2413.84 159.784Z",
    fill: "url(#paint15_linear_31_1859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.85 -19.756L691.791 262.326H1158.22L1521.13 -22.778L1050.85 -19.756Z",
    fill: "url(#paint16_linear_31_1859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.5873 369.04H422.944L-34.4473 728.37L-23.5873 369.04Z",
    fill: "url(#paint17_linear_31_1859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472.88 -10.455L1086.33 293.221H735.271L1115.67 -5.62596L1472.88 -10.455Z",
    fill: "url(#paint18_linear_31_1859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.227 -29.228L-93.7305 423.248V-26.744L482.227 -29.228Z",
    fill: "url(#paint19_linear_31_1859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.943 -121.136L-153.013 331.34V-118.652L422.943 -121.136Z",
    fill: "url(#paint20_linear_31_1859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1917.6 636.923H1589.9L2469.95 -40.036H2794.4L1917.6 636.923Z",
    fill: "url(#paint21_linear_31_1859)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M2400 0H0V800H2400V0Z",
    fill: "#A51E22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3642 124.625C82.0547 124.625 79.097 121.933 79 116.986H83.3396C83.6063 119.872 85.4488 121.473 91.4127 121.473C96.8674 121.473 98.9281 119.993 98.9281 117.787C98.9281 115.434 97.619 114.634 90.8551 114.004C81.788 113.106 79.5334 111.312 79.5334 107.141C79.5334 102.97 83.1456 100.351 90.3702 100.351C98.1766 100.351 101.862 102.412 102.007 107.238H97.619C97.4008 104.716 95.4128 103.6 90.4672 103.6C85.8367 103.6 83.679 104.619 83.679 106.753C83.679 108.887 84.9639 109.736 91.849 110.415C100.674 111.312 103.195 112.767 103.195 117.35C103.195 121.933 99.2676 124.601 91.3884 124.601L91.3642 124.625Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.736 115.313H135.196C135.124 121.521 129.96 124.625 122.032 124.625C113.014 124.625 108.02 120.381 108.02 112.185C108.02 104.837 113.062 100.375 121.766 100.375C130.469 100.375 134.784 103.843 134.954 109.542H130.421C130.251 105.613 127.099 103.843 121.887 103.843C115.85 103.843 112.699 106.607 112.699 112.233C112.699 118.368 115.874 121.085 122.105 121.085C127.099 121.085 130.614 119.217 130.711 115.313H130.736Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M165.284 100.593V114.513C165.284 121.278 161.865 124.455 153.041 124.455C144.677 124.455 141.04 121.472 141.04 114.804V100.593H145.501V114.416C145.501 118.975 147.537 120.987 153.113 120.987C158.689 120.987 160.823 119.047 160.823 114.052V100.593H165.284Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M184.579 100.739C193.647 100.739 197.671 105.128 197.671 112.257C197.671 119.387 193.744 124.261 184.798 124.261H172.7V100.739H184.579ZM177.161 120.866H184.337C190.543 120.866 193.04 117.98 193.04 112.403C193.04 106.825 190.616 104.158 183.852 104.158H177.161V120.866Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M225.333 100.739V103.964H208.557V110.754H221.187V113.906H208.557V121.06H225.333V124.285H204.096V100.763H225.333V100.739Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M249.917 112.67V113.009C252.608 113.3 254.45 114.804 254.45 117.301V124.286H250.086V117.326C250.086 114.973 247.735 114.173 246.014 114.173H235.88V124.286H231.419V100.763H246.765C252.438 100.763 254.959 103.188 254.959 106.898C254.959 110.609 252.632 112.112 249.917 112.67ZM235.88 111.069H246.014C248.995 111.069 250.644 109.93 250.644 107.286C250.644 105.249 249.262 103.915 246.304 103.915H235.88V111.069Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M266.015 100.739V124.261H261.554V100.739H266.015Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M288.197 100.739L300.101 123.291V124.286H295.737L293.022 118.951H277.579L274.863 124.286H270.693V123.291L282.67 100.739H288.221H288.197ZM285.264 103.697L279.203 115.677H291.373L285.264 103.697Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M335.229 100.739V103.964H318.72V112.258H331.617V115.434H318.72V124.261H314.259V100.739H335.229Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M361.897 100.739V103.964H345.121V110.754H357.752V113.907H345.121V121.06H361.897V124.286H340.66V100.763H361.897V100.739Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M386.479 112.67V113.009C389.17 113.3 391.013 114.804 391.013 117.301V124.286H386.649V117.326C386.649 114.973 384.297 114.173 382.576 114.173H372.442V124.286H367.981V100.763H383.328C389.001 100.763 391.522 103.188 391.522 106.898C391.522 110.609 389.195 112.112 386.479 112.67ZM372.442 111.069H382.576C385.558 111.069 387.207 109.93 387.207 107.286C387.207 105.249 385.825 103.915 382.867 103.915H372.442V111.069Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M416.615 112.67V113.009C419.306 113.3 421.148 114.804 421.148 117.301V124.286H416.785V117.326C416.785 114.973 414.409 114.173 412.712 114.173H402.578V124.286H398.117V100.763H413.463C419.136 100.763 421.658 103.188 421.658 106.898C421.658 110.609 419.33 112.112 416.615 112.67ZM402.578 111.069H412.712C415.694 111.069 417.342 109.93 417.342 107.286C417.342 105.249 415.96 103.915 413.003 103.915H402.578V111.069Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M442.725 100.739L454.629 123.291V124.286H450.265L447.55 118.951H432.107L429.392 124.286H425.222V123.291L437.198 100.739H442.75H442.725ZM439.816 103.697L433.755 115.677H445.926L439.816 103.697Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M477.903 112.67V113.009C480.594 113.3 482.437 114.804 482.437 117.301V124.286H478.073V117.326C478.073 114.973 475.721 114.173 474 114.173H463.866V124.286H459.405V100.763H474.751C480.424 100.763 482.946 103.188 482.946 106.898C482.946 110.609 480.618 112.112 477.879 112.67H477.903ZM463.866 111.069H474C476.982 111.069 478.63 109.93 478.63 107.286C478.63 105.249 477.248 103.915 474.291 103.915H463.866V111.069Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M494 100.739V124.261H489.539V100.739H494Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31_1859",
    x1: 900.322,
    y1: 136.714,
    x2: 220.424,
    y2: 715.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31_1859",
    x1: 1272.85,
    y1: -137.826,
    x2: 761.392,
    y2: 581.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_31_1859",
    x1: 64.8374,
    y1: 608.483,
    x2: 513.998,
    y2: 232.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_31_1859",
    x1: 276.23,
    y1: 500.058,
    x2: 646.348,
    y2: 223.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_31_1859",
    x1: 200.655,
    y1: 336.248,
    x2: 496.014,
    y2: 115.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_31_1859",
    x1: -97.0268,
    y1: 345.774,
    x2: 160.629,
    y2: 153.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_31_1859",
    x1: -214.998,
    y1: 637.815,
    x2: 132.876,
    y2: 377.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_31_1859",
    x1: 20.1713,
    y1: 462.726,
    x2: 359.101,
    y2: 209.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_31_1859",
    x1: 1141.98,
    y1: 436.034,
    x2: 1485.93,
    y2: 178.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_31_1859",
    x1: 1393.44,
    y1: 597.841,
    x2: 1823.09,
    y2: 276.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_31_1859",
    x1: 753.282,
    y1: 873.897,
    x2: 1231.38,
    y2: 516.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_31_1859",
    x1: 1757.18,
    y1: 438.419,
    x2: 2046.19,
    y2: 222.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_31_1859",
    x1: 1507.99,
    y1: 385.507,
    x2: 1821.88,
    y2: 150.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_31_1859",
    x1: 1427.62,
    y1: 156.66,
    x2: 1485.59,
    y2: 415.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_31_1859",
    x1: 2089.36,
    y1: 202.623,
    x2: 2145.8,
    y2: 454.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_31_1859",
    x1: 2283.7,
    y1: 204.309,
    x2: 2095.62,
    y2: 538.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_31_1859",
    x1: 1096.28,
    y1: 74.3578,
    x2: 1135.39,
    y2: 248.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_31_1859",
    x1: -34.4471,
    y1: 548.705,
    x2: 422.944,
    y2: 548.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_31_1859",
    x1: 1037.07,
    y1: 246.023,
    x2: 1251.65,
    y2: -89.0799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_31_1859",
    x1: -52.7469,
    y1: 236.907,
    x2: 146.834,
    y2: 22.8643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_31_1859",
    x1: -120.145,
    y1: 194.088,
    x2: 66.3131,
    y2: -35.3992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_31_1859",
    x1: 2295.31,
    y1: 168.921,
    x2: 2039.11,
    y2: 490.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_1859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2259,
    height: 384,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_31_1859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2400,
    height: 800,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFerrariBannerDeep);
export default __webpack_public_path__ + "static/media/ferrari_banner_deep.2c4d8898001918410fb2d0370e343c1b.svg";
export { ForwardRef as ReactComponent };